import React, { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { NPSQuestion as NPSQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#242424',
    marginBottom: '12px',
  },
  npsScale: {
    paddingLeft: '20px',
    paddingRight: '10px',
    width: 'calc(100% - 30px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  scaleRow: {
    display: 'flex',
    gap: '0',
    alignItems: 'stretch',
    width: '100%',
  },
  scaleNumber: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    flex: 1,
    height: '40px',
    backgroundColor: 'white',
    border: '1px solid #d1d1d1',
    borderRight: 'none',
    '&:first-child': {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
    '&:last-child': {
      borderRight: '1px solid #d1d1d1',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
    },
  },
  scaleNumberSelected: {
    backgroundColor: '#e6f2f3',
  },
  numberLabel: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '12px',
    fontWeight: 600,
    color: '#616161',
  },
  labelsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  label: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '12px',
    color: '#616161',
  },
});

interface NPSQuestionViewProps {
  question: NPSQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const NPSQuestionView: React.FC<NPSQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();
  const [score] = useState<string>('');

  return (
    <div className={styles.container} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} data-question-view>
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      <div className={styles.npsScale}>
        <div className={styles.scaleRow}>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
            <div 
              key={num} 
              className={score === num.toString() ? `${styles.scaleNumber} ${styles.scaleNumberSelected}` : styles.scaleNumber}
            >
              <span className={styles.numberLabel}>{num}</span>
            </div>
          ))}
        </div>
        
        <div className={styles.labelsRow}>
          <span className={styles.label}>{question.lowLabel || 'Not at all likely'}</span>
          <span className={styles.label}>{question.highLabel || 'Extremely likely'}</span>
        </div>
      </div>
    </div>
  );
};
